/**
 * Ryan O'Dowd
 * 2022-04-12
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const BORDER_RADIUS = 12;

// @TODO: instead of the `WithRightItem` styles, this should be handled by the components using this component
const getStyles = ({globalScale, fonts, colors}) => {
  return {
    container: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
    },
    containerWithRightItems: {
      flex: 1,
    },
    vertical: {
      flexDirection: 'column',
    },
    optionWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    optionWrapperWithRightItem: {
      flex: 1,
    },
    optionWrapperVertical: {
      flexDirection: 'row',
    },
    sectionTitleAndOptionWrapper: {
      flex: 1,
      flexDirection: 'column',
    },
    sectionTitleAndOptionWrapperHorizontal: {
      width: '100%',
    },
    sectionTitleText: {
      marginTop: globalScale * 8,
      marginBottom: globalScale * 4,
      fontSize: globalScale * 16,
      color: colors.dialogText,
      fontFamily: fonts.secondaryBold,
    },
    option: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: colors.white,
      borderColor: colors.gray,
      borderWidth: 1,
      padding: 8,
      opacity: 0.4,
    },
    optionDense: {
      padding: 4,
    },
    optionWithRightItem: {
      flex: 1,
      width: '100%',
      height: '100%',
      padding: 4,
    },
    optionText: {
      fontSize: globalScale * 16,
      color: colors.primaryExtraDark,
      textAlign: 'center',
    },
    first: {
      borderTopLeftRadius: BORDER_RADIUS,
      borderBottomLeftRadius: BORDER_RADIUS,
    },
    firstVertical: {
      borderTopLeftRadius: BORDER_RADIUS,
      borderTopRightRadius: BORDER_RADIUS,
    },
    last: {
      borderTopRightRadius: BORDER_RADIUS,
      borderBottomRightRadius: BORDER_RADIUS,
    },
    lastVertical: {
      borderBottomLeftRadius: BORDER_RADIUS,
      borderBottomRightRadius: BORDER_RADIUS,
    },
    selected: {
      opacity: 1.0,
      backgroundColor: colors.accentLight,
    },
  };
};

export default getStyles;

// @TODO: below is the initial web code that might be required when fundraising is active again
///**
// * Ryan O'Dowd
// * 2022-07-23
// * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
// */
//
//const BORDER_RADIUS = 12;
//
//const getStyles = ({colors}) => {
//  return {
//    container: {
//      display: 'flex',
//      width: '100%',
//      height: '100%',
//      flexDirection: 'row',
//    },
//    option: {
//      display: 'flex',
//      width: '100%',
//      height: 20,
//      cursor: 'pointer',
//      justifyContent: 'center',
//      alignItems: 'center',
//      color: colors.white,
//      backgroundColor: colors.primaryDark,
//      borderColor: colors.primaryExtraDark,
//      borderStyle: 'solid',
//      padding: 10,
//      borderWidth: 1,
//      opacity: 0.8,
//    },
//    first: {
//      borderTopLeftRadius: BORDER_RADIUS,
//      borderBottomLeftRadius: BORDER_RADIUS,
//    },
//    middle: {
//      borderLeft: 'none',
//    },
//    last: {
//      borderTopRightRadius: BORDER_RADIUS,
//      borderBottomRightRadius: BORDER_RADIUS,
//      borderLeft: 'none',
//    },
//    selected: {
//      opacity: 1.0,
//      color: colors.primaryExtraDark,
//      backgroundColor: colors.accent,
//    },
//    customAmountText: {
//      fontSize: 12,
//    },
//    customInput: {
//      margin: 0,
//      padding: 4,
//      border: 'none',
//      borderBottom: '2px solid',
//      borderColor: colors.primary,
//      width: 220,
//      fontSize: 16,
//      outline: 'none',
//    },
//  };
//};
//
//export default getStyles;
